import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/login")({
  head: () => ({
    meta: [
      { title: "Iniciar sesión — Mostrando México" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/auth", search: search as never, statusCode: 301 });
  },
});
